import STATIC_DATA from '@/util/static-data'
import Util from '@/util/util'
import { flowStatusCodeFilter } from '@/util/preservation-static'
import {province as provinceList, city as cityList, area as areaList} from '@/util/address-data'
import {
    formatDate,
} from '_libs/util/base';
const WebP = new Image();
let isSuppertWebp = false
WebP.onload = WebP.onerror = function () {
  if (WebP.height != 2) {
    isSuppertWebp = false
  } else {
    isSuppertWebp = true
  }
};
WebP.src = 'data:image/webp;base64,UklGRjoAAABXRUJQVlA4IC4AAACyAgCdASoCAAIALmk0mk0iIiIiIgBoSygABc6WWgAA/veff/0PP8bA//LwYAAA';


export default {
    install (Vue, options) {
      Vue.filter('imgFilter', function(value) {
        if (isSuppertWebp) {
          value = value + '?x-oss-process=image/format,webp'
        }
        return value
      })
        Vue.filter('groupCardTypeFilter', type => {
            return STATIC_DATA.GROUP_ID_TYPES[type] || ''
        })

        Vue.filter('insuredHasSocialSecFilter', type => {
            return STATIC_DATA.insuredHasSocialSecS[Number(type)] || ''
        })

        Vue.filter('idTypeFilter', type => {
            return STATIC_DATA.ID_TYPES[type] || ''
        })
        Vue.filter('isHighJobFilter', type => {
            return type ? '涉高' : '不涉高'
        })

        Vue.filter('sexFilter', type => {
            return STATIC_DATA.GENDERS[type] || ''
        })

        Vue.filter('formatDate', (date, format) => {
            return formatDate(date, format)
        })
        Vue.filter('dateFilter', (date, format) => {
            return Util.dateFormat(date, format)
        })

        Vue.filter('numberToChineseFilter', num => {
            return Util.numberToChinese(num)
        })

        Vue.filter('companyLogoFilter', (id, list) => {
            let c = list.filter(item => {
                return item.id == id
            })
            if (c.length > 0) {
                return c[0].logoUrl
            } else {
                return ''
            }
        })

        Vue.filter('orderStatusFilter', (code) => {
            let des = STATIC_DATA.ORDER_DESCS[code]
            return des
        })

        Vue.filter('getInsureTime', (level1ClauseId, productMsg) => {
            if (productMsg && productMsg.groupClauseInfoExList) {
                let duration = productMsg.groupClauseInfoExList.find((_duration) => {
                    return _duration.id === level1ClauseId
                })
                if (duration) {
                    return duration.clauseDesc
                }
            }
            return ''
        })

        Vue.filter('getAreaString', function(p, c, d) {
            let pStr = provinceList.filter(function (item) {
                    return item.code == p
                })[0].name || '';
            let cStr = cityList.filter(function (item) {
                    return item.code == c
                })[0].name || '';
            let area = areaList.filter(function (item) {
                return item.code == d
            })[0];
            let dStr = area ? area.name : '';
            return pStr + cStr + dStr;
        });


        Vue.filter('flowStatusCodeDesc', function(code) {
            switch (code) {
                case 10:
                  return '待上传'
                case 20:
                  return '待付款'
                case 21:
                  return '付款待确认（对公转账）'
                case 30:
                  return '资料待初审'
                case 31:
                  return '保全待终审'
                case 40:
                  return '保全成功'
                case 50:
                  return '保全关闭'
                case 51:
                  return '支付失败'
                case 52:
                  return '保全驳回'
                case 53:
                  return '已退保'
                default:
                  return ''
                // return '保全失败'
              }
        });

        Vue.filter('statusCodeFilter', function(code,flowStatusCode) {
            const flowStatusMsg = flowStatusCode ? flowStatusCodeFilter(flowStatusCode) : '';
            if(flowStatusMsg) return flowStatusMsg;
          switch (code) {
              case 0:
                return '待完善'
              case 1:
                return '待上传'
              case 2:
                return '待支付'
              case 3:
                return flowStatusCode ==  30 ? '资料待初审' : flowStatusCode ==  31 ? '保全待终审' : '审核中'
              case 4:
                return '成功'
              case 5:
                return '失败'
              default:
                return ''
              // return '保全失败'
            }
      });


      Vue.filter('jobDescFilter', function(desc, jobType) {
        let array = desc.split('-')
        let val = ''
        if (jobType) {
            val = jobType.indexOf('1') + 1
        }
        for (let i = array.length - 1; i > 0; i--) {
            if (array[i] === array[i - 1]) {
                array[i] = ''
            }
        }
        for (let i = 0; i < array.length; i++) {
            if (array[i] === '') {
                array.splice(i, 1)
                i--
            }
        }
        desc = array.join('-');
        if (desc.lastIndexOf('类') === desc.split('').length - 1) {
            desc += '职业'
        } else if (val) {
            desc += '-' + val + '类职业'
        }
        return desc
      });

        Vue.filter('planDescFilter', function(n) {
          return {
            1: '保障计划一',
            2: '保障计划二',
            3: '保障计划三',
            4: '保障计划四',
            5: '保障计划五',
            6: '保障计划六',
            7: '保障计划七',
            8: '保障计划八',
            9: '保障计划九',
            10: '保障计划十',
          }[parseInt(n)]
        });

        Vue.filter('jobTypeFilter', function(n) {
          return {
            '100000':'1',
            '010000':'2',
            '001000':'3',
            '000100':'4',
            '000010':'5',
            '000001':'6',
          }[n]
        });
    }
}



// WEBPACK FOOTER //
// ./src/util/filter.js